import * as catalogos from './catalogos/en';
export const locale = {
    lang: 'en',
    data: {
      'SECCIONES': {
        'NOTATITULO':'Note: ',
        'RANGOS':{
          '1':'Null',
          '2':'Under',
          '3':'Medium',
          '4':'High',
          '5':'Very high',
        },
        'EXCEL':{
          'RESULTS':'NOM035_STP_2018 results ',
          'DESCARG_EXCEL':'Downloading excel',
        },
        'MENU' :{
          'INTRODUCCION':'Introduction',
          'GENERALES':'General',
          'NO_RESPONDIERON': 'No response',
          'ACONTECIMIENTOS_TRAUMATICOS': 'Traumatic events',
          'AT_RESPUESTAS_ENCUESTA':'Survey answers',
          'SUFRIERON_ACONTECIMIENTO_TRAUMATICO': 'They witnessed or suffered an event',
          'REQUIEREN_ATENCION_CLINICA': 'They require clinical care',
          'FRP': 'Psychosocial risk factors',
          'FR_RESPUESTAS_ENCUESTA':'Survey answers',
          'RESPUESTAS_INDIVIDUALES':'Individual results',
          'TABLEROS': 'Boards',
          'TABLERO_GLOBAL': 'Global',
          'TABLERO_CATEGORIA':'By category',
          'TABLERO_DOMINIO': 'By domain',
          'CALIFICACIONFINAL': 'Final qualification'
        },

        'PRINCIPAL' :{
          'BUSCADOR':'Search for a work center',
          'CT':'Workplace',
          'DIRECCION': 'Address',
          'TIPOCONTRATACION':'Type of work center',
          'ACCIONES': 'Actions',
          'BOTONRESULTADOS': 'See results',
          'DESBOTONRESULTADOS': 'Download results',
          'MAS_50':'More than 50',
          'MENOS_50':'Less than 50',
          'PLACE':'Work center name'
        },

        'INTRODUCCION' :{
          'TITULO':'RESULTS OF THE NOM-035-STPS-2018',
        },

        'GENERALES' :{
          'TITULO':'General information',
          'EMPRESA':'Company: ',
          'CT':'Workplace: ',
          'DOMICILIO':'Address: ',
          'ACTIVIDAD_P':'Main activity: ',
          'OBJETIVO':'Objective: ',
          'P_ACTIVIDADESREALIZADAS':'Main activities carried out: ',
          'TOTAL_COLABORADORES':'Total number of collaborators: ',
          'FECHA_APLICACION':'Date of application: ',
          'TOTAL_ENCUESTADOS':'Total number of respondents: ',
          'COLABORADORES_NOACEPTARON':'Employees who did not agree to take the survey: ',
          'COLABORADORES_SUJETOS_ATS':'Employees subject to severe traumatic events that require attention: ',
          'PORCENTAJE_PARTICIPACION':'Percentage of participation',
          'PORCENTAJE_NOPARTICIPACION':'Percentage of non-participation',
          'PERSONAS':' People',
        },

        'NO_RESPONDIERON' :{
          'TITULO':'Collaborators who did not agree to answer the survey',
          'NOMBRE':'Contributor\'s name',
          'MENSAJE':'All of your collaborators have agreed to answer the survey'
        },

        'AT_RESPUESTAS_ENCUESTA' :{
          'TITULO':'Survey responses to identify workers who were subjected to severe traumatic events',
          'PREGUNTA':'Question',
          'RESPUESTA':'Answer',
          'SI':'Yes',
          'NO':'No'
        },

        'SUFRIERON_ACONTECIMIENTO_TRAUMATICO' :{
          'TITULO':'Employees who witnessed or experienced a traumatic event at work or during work',
          'NOMBRE_COLABORADOR':'Contributor\'s name',
          'MENSAJE':'No employee has ever witnessed or suffered, during or on the occasion of work, a traumatic event'
        },

        'REQUIEREN_ATENCION_CLINICA' :{
          'TITULO':'Employees who suffered a severe traumatic event and require clinical care',
          'NOMBRE_COLABORADOR':'Contributor\'s name',
          'MENSAJE':'No employee has suffered a severe traumatic event and therefore none requires clinical attention'
        },

        'FR_RESPUESTAS_ENCUESTA' :{
          'TITULO-50':'Answers to the questionnaire to identify psychosocial risk factors in the workplace',
          'TITULO2+50':'Questionnaire responses to identify psychosocial risk factors and assess the organizational environment in the workplace',
          'PREGUNTA':'Question',
          'SIEMPRE':'Always',
          'CASI_SIEMPRE':'Almost always',
          'ALGUNAS_VECES':'Sometimes',
          'CASI_NUNCA':'Hardly ever',
          'NUNCA':'Never'
        },

        'RESPUESTAS_INDIVIDUALES' :{
          'TITULO-50':'Individual survey responses to identify psychosocial risk factors in the workplace',
          'TITULO2+50':'Individual survey responses to identify psychosocial risk factors and assess the organizational environment in the workplace',
          'NOMBRE_COLABORADOR':'Contributor\'s name'
        },

        'TABLERO_GLOBAL' :{
          'TITULO':'Results table by category, domain and dimension',
          'CATEGORIA':'Category',
          'DOMINIO':'Domain',
          'DIMENSION':'Dimension',
          'NOTA':'The numbers of the categories and domains are the average of the answers of their dimensions.'
        },

        'TABLERO_CATEGORIA' :{
          'TITULO':'Results table by category',
          'CATEGORIA':'Category',
          'NOTA':'The category numbers are the average of the responses for the dimensions of your domain.',
          'LABEL':'Results by category'
        },

        'TABLERO_DOMINIO' :{
          'TITULO':'Results table by domain',
          'DOMINIO':'Domain',
          'NOTA':'The domain numbers are the average of the answers of their dimensions.',
          'LABEL':'Results by domain'
        },
            'CALIFICACIONFINAL' :{
              'TITULO':'Final qualification',
              'NOTA':'The final score is the average of the sum of all the questions in the survey.',
              'TEXTOCALIFICACION': catalogos.textoCalificacion,
            }

        }
      }
};
